import styled from 'styled-components';

import GridContainer from '../../sharedComponents/DropdownWithTips/layout/grid';
import { mediaBreakpoint } from '../../utils/mediaBreakpoint';

type Props = {
    columns?: string;
    rows?: string;
};

const LabelAndValueDlContainer = styled(GridContainer).attrs({
    as: 'dl',
})<Props>`
    font-size: 0.875rem;
    dt {
        font-weight: 800;
    }

    dd {
        grid-column: 2/4;

        ${mediaBreakpoint.down('md')} {
            ${({ theme }) => theme.TextStyles.span.Text14Left}
        }
    }
`;

export default LabelAndValueDlContainer;
